export class WindowVisibilityService {
    private isVisible: boolean;
    private eventListeners: JQueryCallback;
    private hiddenPropertyName: string;

    private static instance: WindowVisibilityService;

    private constructor() {
        let [prefix, hiddenPropertyName] = this.getBrowserPrefix();

        this.eventListeners = $.Callbacks();
        this.hiddenPropertyName = hiddenPropertyName;
        this.isVisible = this.getWindowVisibility();

        const visibilityEventName = this.getVisibilityEventName(prefix);

        $(document)
            .on(visibilityEventName, this.handleVisibilityChange.bind(this))
            .on('focus', this.handleVisibilityChange.bind(this, true))
            /*.on('blur', this.handleVisibilityChange.bind(this, false))*/;

        $(window)
            .on('focus', this.handleVisibilityChange.bind(this, true))
            /*.on('blur', this.handleVisibilityChange.bind(this, false))*/;
    }

    public static change(listener: Function) {
        this.getInstance().eventListeners.add(listener);
    }

    public static unbind(listener: Function) {
        this.getInstance().eventListeners.remove(listener);
    }

    public static getVisibilityStatus() {
        return this.getInstance().isVisible;
    }

    private static getInstance() {
        return WindowVisibilityService.instance || (WindowVisibilityService.instance = new WindowVisibilityService());
    }

    private handleVisibilityChange(isVisible?: boolean) {
        isVisible = typeof(isVisible) === 'boolean'
            ? isVisible
            : this.getWindowVisibility();

        if (this.isVisible === isVisible)
            return;

        this.isVisible = isVisible;

        this.eventListeners.fire(isVisible);
    }

    private getBrowserPrefix(): [string, string] {
        let hiddenPropertyName;

        for (let prefix of ['moz', 'ms', 'o', 'webkit']) {
            if ((hiddenPropertyName = this.getHiddenPropertyName(prefix)) in document) {
                return [prefix, hiddenPropertyName];
            }
        }

        return ['', this.getHiddenPropertyName()];
    }

    private getWindowVisibility() {
        return !(document as any)[this.hiddenPropertyName];
    }

    private getHiddenPropertyName(prefix?: string): string {
        return prefix
            ? prefix + 'Hidden'
            : 'hidden';
    }

    private getVisibilityEventName(prefix: string): string {
        return `${prefix}visibilitychange`;
    }
}



// WEBPACK FOOTER //
// ./utils/WindowVisibilityService.ts